import React, { useEffect, useState } from "react";
import Display from "./Display";
import PilihLayanan from "./PilihLayanan";

export default function LihatAntrian() {
  const tenantIdsFromParams = window.location.search
    ? new URLSearchParams(window.location.search)
        .get("id")
        .split(",")
        .map((e) => parseInt(e))
    : [];
  return tenantIdsFromParams.length > 0 ? <Display /> : <PilihLayanan />;
}
